@if (isIssuingOffice === false) {
  <ng-container [formGroup]="addressForm">
    <div class="grid-row grid-gap-0">
      @if (showDefaultAddress) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
          <input class="usa-checkbox__input" id="defaultAddress" type="checkbox" formControlName="defaultAddress" />
          <label class="usa-checkbox__label" for="defaultAddress">Default Preferred Address</label>
        </div>
      }
    </div>
    <div class="grid-row grid-gap-0">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
        <label for="addressLine1" class="usa-label">
          {{showLocation ? 'Location' : 'Line 1 Address'}}
          @if (isRequiredAddress) {
            <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr>
          }</label>
          @if (showDefaultAddress) {
            <input
              id="addressLine1"
              type="text"
              placeholder="Enter Address"
              name="addressLine1"
              class="usa-input"
              formControlName="addressLine1"
              />
          }
          <ng-template #addressSearchTemplate let-model="item" let-index="index">
            {{model.addressLine1}} - {{model.addressLine2}}
          </ng-template>
          @if (!showDefaultAddress) {
            <input type="text" placeholder="Enter Address" id="typeaheadAddressLine1" class="usa-input" formControlName='addressLine1'
              (typeaheadOnSelect)="typeaheadAddressOnSelect($event)" [typeaheadScrollable]="true"
              [typeaheadItemTemplate]="addressSearchTemplate"
              [typeahead]="shipmentPreferredAddresses" typeaheadOptionField="addressLine1"
              [typeaheadMinLength]="2" [typeaheadOptionsLimit]="10" [maxlength]="100">
          }
          @if (
            addressForm.get('addressLine1').invalid &&
            (addressForm.get('addressLine1').touched ||
            addressForm.get('addressLine1').dirty) &&
            addressForm.get('addressLine1').errors.required
            ) {
            <div
              >
              <small class="text-danger">
                <span class="fa fa-warning"></span> {{showLocation ? 'Location is required!' : 'Line 1 Address is required!'}}
              </small>
            </div>
          }
          @if (
            addressForm.get('addressLine1').invalid &&
            (addressForm.get('addressLine1').touched ||
            addressForm.get('addressLine1').dirty) &&
            addressForm.get('addressLine1').errors.maxlength
            ) {
            <div
              >
              <small class="text-danger">
                <span class="fa fa-warning"></span>
                {{showLocation ? 'Line 1 Address length is 100 characters!' : 'Location max length is 100 characters!'}}
              </small>
            </div>
          }
        </div>
        @if (showLocation) {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
            <label for="addressLine2" class="usa-label">Address
              @if (isRequiredAddress) {
                <abbr title="required"
                class="usa-hint usa-hint--required">*</abbr>
              }</label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
                />
              @if (
                addressForm.get('addressLine2').invalid &&
                (addressForm.get('addressLine2').touched ||
                addressForm.get('addressLine2').dirty) &&
                addressForm.get('addressLine2').errors.required
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Address is required!
                  </small>
                </div>
              }
              @if (
                addressForm.get('addressLine2').invalid &&
                (addressForm.get('addressLine2').touched ||
                addressForm.get('addressLine2').dirty) &&
                addressForm.get('addressLine2').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Address max length is 100
                    characters!
                  </small>
                </div>
              }
            </div>
          }
          @if (!showLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="addressLine2" class="usa-label">{{showLocation ? 'Address' : 'Line 2 Address'}}</label>
              <input
                id="addressLine2"
                type="text"
                placeholder="Enter Line 2 Address"
                name="addressLine2"
                class="usa-input                                                                                                                         "
                formControlName="addressLine2"
                />
              @if (
                addressForm.get('addressLine2').invalid &&
                (addressForm.get('addressLine2').touched ||
                addressForm.get('addressLine2').dirty) &&
                addressForm.get('addressLine2').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Address max length is 100
                    characters!
                  </small>
                </div>
              }
            </div>
          }
        </div>
        <div class="grid-row grid-gap-0">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="country" class="usa-label">Country
              @if (isRequiredAddress) {
                <abbr title="required"
                class="usa-hint usa-hint--required">*</abbr>
              }</label>
              <select
                id="country"
                name="country"
                class="usa-select"
                formControlName="countryId"
                >
                <option value="">..Select a Country..</option>
                @for (country of countries; track country) {
                  <option
                    [ngValue]="country.stateCountryId"
                    >{{ country.stateCountryName }}
                  </option>
                }
              </select>
            </div>
            @if (this.addressForm.get('searchString')) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4"
                >
                <ng-template #customItemTemplate let-model="item"
                  >{{ model.cityName }}, {{ model.stateAbbrev }} {{ model.zipCode }}
                </ng-template>
                <label for="searchString" class="usa-label">Search </label>
                <input
                  id="searchString"
                  class="usa-input"
                  formControlName="searchString"
                  name="searchString"
                  [typeaheadAsync]="true"
                  [typeahead]="dataShipperSearchAddressResults$"
                  typeaheadOptionField="cityName"
                  [typeaheadItemTemplate]="customItemTemplate"
                  (typeaheadOnSelect)="typeaheadShipperOnSelect($event)"
                  [typeaheadWaitMs]="1000"
                  [typeaheadScrollable]="true"
                  [typeaheadOptionsInScrollableView]="10"
                  [typeaheadOptionsLimit]="100"
                  placeholder="Type a location or zip"
                  />
              </div>
            }
          </div>
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="city" class="usa-label">City
                @if (isCountrySelectedUSA && isRequiredAddress) {
                  <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
                }
              </label>
              <input
                id="city"
                type="text"
                formControlName="city"
                name="city"
                class="usa-input"
                placeholder="Enter city"
                />
              @if (
                addressForm.get('city').invalid &&
                (addressForm.get('city').touched || addressForm.get('city').dirty) &&
                addressForm.get('city').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> city max length is 45 characters!
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="state" class="usa-label">State
                @if (isCountrySelectedUSA && isRequiredAddress) {
                  <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
                }
              </label>
              <input
                id="state"
                type="text"
                formControlName="state"
                name="state"
                class="usa-input"
                placeholder="Enter State"
                />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="zipCode" class="usa-label">Zip Code
                @if (isCountrySelectedUSA && isRequiredAddress) {
                  <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
                }
              </label>
              <input
                id="zipCode"
                type="text"
                name="zipCode"
                formControlName="zipCode"
                class="usa-input"
                placeholder="Enter Zip / Pin"
                />
              @if (
                addressForm.get('zipCode').invalid &&
                (addressForm.get('zipCode').touched ||
                addressForm.get('zipCode').dirty) &&
                addressForm.get('zipCode').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> zipCode max length is 6
                    characters!
                  </small>
                </div>
              }
              @if (
                addressForm.get('zipCode').invalid &&
                (addressForm.get('zipCode').touched ||
                addressForm.get('zipCode').dirty) &&
                addressForm.get('zipCode').errors.numeric
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> zipCode must be numeric
                    characters!
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phone" class="usa-label">Primary Phone
                @if (isRequiredAddress) {
                  <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
                }
              </label>
              <input
                id="phone"
                type="text"
                placeholder="Enter primary phone"
                class="usa-input"
                name="phone"
                formControlName="phone"
                />
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.required
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Primary Phone is required!
                  </small>
                </div>
              }
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.numeric
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Primary Phone is invalid - should
                    be all numeric, no dashes, no spaces
                  </small>
                </div>
              }
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.minlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Primary Phone should be at least
                    10 digits long
                  </small>
                </div>
              }
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Primary Phone max length is 20
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="phoneExt" class="usa-label">Ext</label>
              <input
                type="text"
                id="phoneExt"
                placeholder="Enter phone extension"
                name="phoneExt"
                class="usa-input"
                [maxLength]="10"
                formControlName="phoneExt"
                />
              @if (
                addressForm.get('phoneExt').invalid &&
                (addressForm.get('phoneExt').touched ||
                addressForm.get('phoneExt').dirty) &&
                addressForm.get('phoneExt').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Phone ext max length is 10
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="alternatePhone" class="usa-label">Alternative Phone</label>
              <input
                id="alternatePhone"
                type="text"
                placeholder="Enter alternative phone"
                name="alternatePhone"
                class="usa-input"
                formControlName="alternatePhone"
                />
              @if (
                addressForm.get('alternatePhone').invalid &&
                (addressForm.get('alternatePhone').touched ||
                addressForm.get('alternatePhone').dirty) &&
                addressForm.get('alternatePhone').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Alternative phone max length is
                    45!
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="emailAddress" class="usa-label">Email
                @if (isRequiredAddress) {
                  <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
                }
              </label>
              <input
                id="emailAddress"
                type="text"
                placeholder="Enter email"
                name="emailAddress"
                class="usa-input"
                formControlName="emailAddress"
                />
              @if (
                (addressForm.get('emailAddress').dirty ||
                addressForm.get('emailAddress').touched) &&
                addressForm.get('emailAddress').invalid &&
                addressForm.get('emailAddress').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Email cannot exceed 45 characters!
                  </small>
                </div>
              }
              @if (
                (addressForm.get('emailAddress').dirty ||
                addressForm.get('emailAddress').touched) &&
                addressForm.get('emailAddress').invalid &&
                addressForm.get('emailAddress').hasError('email')
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Please enter a valid email!
                  </small>
                </div>
              }
              @if (
                (addressForm.get('emailAddress').dirty ||
                addressForm.get('emailAddress').touched) &&
                addressForm.get('emailAddress').invalid &&
                addressForm.get('emailAddress').errors.required
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Email is required!
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="otherContactInfo" class="usa-label">Other Contact/POC Information</label>
              <input
                id="otherContactInfo"
                type="text"
                placeholder="Enter other contact or POC information"
                name="otherContactInfo"
                class="usa-input"
                formControlName="otherContactInfo"
                />
            </div>
          </div>
        </ng-container>
      }
      @if (isIssuingOffice === true) {
        <ng-container [formGroup]="addressForm">
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeName" class="usa-label">Office Name</label>
              <input
                type="text"
                id="issuingOfficeName"
                placeholder="Enter the Office Name"
                name="issuingOfficeName"
                class="usa-input"
                formControlName="issuingOfficeName"
                />
              @if (
                addressForm.get('issuingOfficeName').invalid &&
                (addressForm.get('issuingOfficeName').touched ||
                addressForm.get('issuingOfficeName').dirty) &&
                addressForm.get('issuingOfficeName').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Issuing officer name max length is
                    45!
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficePhone" class="usa-label">Phone</label>
              <input
                type="text"
                id="issuingOfficePhone"
                placeholder="Enter phone number"
                name="issuingOfficePhone"
                class="usa-input"
                formControlName="phone"
                />
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Phone max length is 20!
                  </small>
                </div>
              }
              @if (
                addressForm.get('phone').invalid &&
                (addressForm.get('phone').touched ||
                addressForm.get('phone').dirty) &&
                addressForm.get('phone').errors.minlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Phone min length is 10!
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficerTitle" class="usa-label">Officer Title</label>
              <input
                type="text"
                placeholder="Enter the Officer Title"
                id="issuingOfficerTitle"
                class="usa-input"
                formControlName="issuingOfficerTitle"
                name="issuingOfficerTitle"
                />
              @if (
                addressForm.get('issuingOfficerTitle').invalid &&
                (addressForm.get('issuingOfficerTitle').touched ||
                addressForm.get('issuingOfficerTitle').dirty) &&
                addressForm.get('issuingOfficerTitle').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Issuing officer Title max length
                    is 20!
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap-0">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerFirstName" class="usa-label">Officer First Name</label>
              <input
                type="text"
                placeholder="Enter Officer First Name"
                id="issuingOfficeOfficerFirstName"
                class="usa-input"
                formControlName="firstName"
                name="firstName"
                />
              @if (
                addressForm.get('firstName').invalid &&
                (addressForm.get('firstName').touched ||
                addressForm.get('firstName').dirty) &&
                addressForm.get('firstName').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Issuing officer First name max
                    length is 45!
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerMiddleInitial" class="usa-label">Middle Initial</label>
              <input
                type="text"
                placeholder="Enter Officer Middle Initial"
                id="issuingOfficeOfficerMiddleInitial"
                class="usa-input"
                formControlName="middleInitial"
                />
              @if (
                addressForm.get('middleInitial').invalid &&
                (addressForm.get('middleInitial').touched ||
                addressForm.get('middleInitial').dirty) &&
                addressForm.get('middleInitial').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Issuing officer middle initial max
                    length is 1!
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-4">
              <label for="issuingOfficeOfficerLastName" class="usa-label">Officer Last Name</label>
              <input
                type="text"
                placeholder="Enter Officer Last Name"
                id="issuingOfficeOfficerLastName"
                class="usa-input"
                formControlName="lastName"
                name="lastName"
                />
              @if (
                addressForm.get('lastName').invalid &&
                (addressForm.get('lastName').touched ||
                addressForm.get('lastName').dirty) &&
                addressForm.get('lastName').errors.maxlength
                ) {
                <div
                  >
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Issuing officer last name max
                    length is 45!
                  </small>
                </div>
              }
            </div>
          </div>
        </ng-container>
      }
